import { Grid, Typography } from "@material-ui/core";
import FacebookIcon from "@material-ui/icons/Facebook";
import YouTubeIcon from "@material-ui/icons/YouTube";
import InstagramIcon from "@material-ui/icons/Instagram";
import React from "react";
import "./Footer.css";
import { useHistory } from "react-router-dom";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import PinDropIcon from "@material-ui/icons/PinDrop";
import EmailIcon from "@material-ui/icons/Email";

function Footer() {
  const history = useHistory();
  return (
    <div className="footerfooter">
      <div className="footer">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={6}>
            <div className="footer-left1">
              <Typography className="topic">Get in touch</Typography>
              <Typography className="body">
                Thank you very much for visting my website If you want to know
                more about me you can directly contact me or email me I'm very
                presure to respon you.
              </Typography>
              <div className="social-media">
                <div className="media">
                  <AssignmentIndIcon />
                  <div className="info">
                    <Typography className="text">Name:</Typography>
                    <Typography className="text">paokue SAOLONG</Typography>
                  </div>
                </div>
                <div className="media">
                  <PinDropIcon />
                  <div className="info">
                    <Typography className="text">Address:</Typography>
                    <Typography className="text">
                      Vientiane province, Laos
                    </Typography>
                  </div>
                </div>
                {/* <hr /> */}
                <div className="media">
                  <EmailIcon />
                  <div className="info">
                    <Typography className="text">Email:</Typography>
                    <Typography className="text">paokue77@gmail.com</Typography>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <div className="footer_left">
              <img src="/image/pao.jpg" alt="paokue" />
              <div className="footer_name">paokue SAOLONG</div>
              <br />
              <div className="footer_socail">
                <a
                  href="https://www.facebook.com/profile.php?id=100025376432574"
                  style={{ fontFamily: "Caveat", fontSize: "22px" }}
                >
                  <FacebookIcon style={{ color: "blue" }} />
                </a>
                &nbsp; &nbsp; &nbsp;
                <a
                  href="https://www.youtube.com/channel/UCBWlz-zXn8-7drz183u56lQ"
                  style={{ fontFamily: "Caveat", fontSize: "22px" }}
                >
                  <YouTubeIcon style={{ color: "red" }} />
                </a>
                &nbsp; &nbsp; &nbsp;
                <a href="#" style={{ fontFamily: "Caveat", fontSize: "22px" }}>
                  <InstagramIcon style={{ color: "purple" }} />
                </a>
                &nbsp; &nbsp; &nbsp;
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <div className="footer_right">
              <Typography
                className="footer_right_text"
                onClick={() => history.push("/register")}
              >
                Terms & Conditions
              </Typography>
              <Typography
                className="footer_right_text"
                onClick={() => history.push("/coursehomepage")}
              >
                Courses
              </Typography>
              <Typography
                className="footer_right_text"
                onClick={() => history.push("/contact")}
              >
                Contact us
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
      <Typography className="footerType">
        Copyright <span>@</span> by paokue in <span>2021</span>
      </Typography>
    </div>
  );
}

export default Footer;
